import type React from "react";

interface LoadingPageProps {
  title?: string;
}

const LoadingPage: React.FC<LoadingPageProps> = ({ title = "Loading..." }) => {
  return (
    <div role="status" aria-live="polite" className="z-10 h-full w-full place-content-center">
      <div className="loading-container">
        <span className="icon-sync animate-spin text-blue-600 text-5xl" />
      </div>
      <div className="loading-text">{title}</div>
    </div>
  );
};

export default LoadingPage;
